import { Skeleton } from "@/components/ui/skeleton";
import { Separator } from "@base-ui/react/separator";

type BookingHistoryDetailsSkeletonProps = {
  isReturn?: boolean;
   passengerCount?: number;
};

export function BookingHistoryDetailsSkeleton({
  isReturn = false,
  passengerCount = 1,
}: BookingHistoryDetailsSkeletonProps) {
    return (
      <div className="max-w-7xl mx-auto px-4 pt-4 pb-16 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-start md:justify-between">
          <div className="flex items-center gap-2">
            <Skeleton className="h-4 w-20 rounded-md" />
          </div>
          <div className="mt-8 grid grid-cols-2 gap-4 md:mt-0">
            <Skeleton className="h-12 w-40 rounded-xl" />
            <Skeleton className="h-12 w-40 rounded-xl" />
          </div>
        </div>

        <Skeleton className="h-4 w-40 mt-8 rounded-md" />
        <div className="rounded-2xl mt-2 p-4 bg-card shadow-xl">
          <div className="grid grid-cols-1 items-center gap-4 md:grid-cols-[3fr_7fr]">
            <Skeleton className="h-60 w-full rounded-md" />
            <div>
              <Skeleton className="h-4 w-32 rounded-md" />
              <div className="mt-4 flex items-stretch gap-4">
                <div className="flex-1">
                  <Skeleton className="h-4 w-24 rounded-md" />
                  <Skeleton className="h-4 w-32 mt-2 rounded-md" />
                </div>
                {isReturn && (
                  <>
                    <Separator
                      orientation="vertical"
                      className="w-px bg-border"
                    />

                    <div className="flex-1">
                      <Skeleton className="h-4 w-24 rounded-md" />
                      <Skeleton className="h-4 w-32 mt-2 rounded-md" />
                    </div>
                  </>
                )}
              </div>
              <div className="mt-4 border-t border-border pt-4">
                <Skeleton className="h-4 w-32 rounded-md" />
                <div className="mt-2 flex gap-4">
                  {Array.from({ length: passengerCount }).map((_, index) => (
                    <div key={index}>
                      <Skeleton className="h-4 w-24 rounded-md" />
                      <Skeleton className="h-16 w-16 mt-2 rounded-md" />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
          <div className="mt-4 border-t border-border pt-4">
            <div className="grid grid-cols-1 items-center md:grid-cols-2">
              <div>
                <Skeleton className="h-4 w-40 rounded-md" />
                <Skeleton className="h-4 w-64 mt-3 rounded-md" />
              </div>
              <div className="mt-4 md:mt-0 flex items-center justify-end">
                <Skeleton className="h-12 w-40 rounded-xl" />
              </div>
            </div>
          </div>
          <div className="mt-4 flex items-start justify-between gap-4 md:grid md:grid-cols-2">
            <div>
              <Skeleton className="h-4 w-64 rounded-md" />
              <Skeleton className="h-4 w-40 mt-3 rounded-md" />
            </div>
            <div>
              <Skeleton className="h-4 w-20 rounded-md" />
              <Skeleton className="h-4 w-40 mt-3 rounded-md" />
            </div>
          </div>
        </div>

        <Skeleton className="h-4 w-40 mt-8 rounded-md" />
        <div className="rounded-2xl mt-2 p-4 bg-card shadow-xl">
          <div className="flex flex-col justify-between gap-4 md:grid md:grid-cols-3 md:items-center">
            <div>
              <Skeleton className="h-4 w-40 rounded-md" />
              <Skeleton className="h-4 w-64 mt-3 rounded-md" />
            </div>
            <div className="mt-4 flex justify-between gap-4 md:mt-0">
              <div>
                <Skeleton className="h-4 w-40 rounded-md" />
                <Skeleton className="h-4 w-64 mt-3 rounded-md" />
              </div>
              <div>
                <Skeleton className="h-4 w-40 rounded-md" />
                <Skeleton className="h-4 w-64 mt-3 rounded-md" />
              </div>
            </div>
            <div className="md:flex md:justify-end">
              <Skeleton className="h-12 w-40 rounded-xl" />
            </div>
          </div>
        </div>

        <Skeleton className="h-4 w-40 mt-8 rounded-md" />
        <Skeleton className="h-28 w-full mt-4 rounded-md" />

        <Skeleton className="h-4 w-40 mt-8 rounded-md" />
        <Skeleton className="h-28 w-full mt-4 rounded-md" />
      </div>
    );
}